import store from 'store';
import {
  ACT_GET_ACTS,
  ACT_GET_ACT,
  GET_REQUIRED_DOCUMENTATION,
  ACT_CMS,
  SET_ACT_PROPERTY,
  ACT_GET_TRANSFER_ACT
} from 'store/actions/act';
import { UI_GET_CHEKINOUT_MASTER_DATA } from 'store/actions/ui';
import { lsGetAct, lsGetTransferAct } from 'helpers/store';
import { APP_ROLES } from 'store/enums';

const Layout = () =>
  import(
    /* webpackChunkName: "views/modules/checkinout" */ 'views/modules/CheckInOut/LayoutCheckInOut'
  );
const ManagerActs = () =>
  import(/* webpackChunkName: "pages/views/modules/checkinout" */ 'views/modules/CheckInOut');
const ActClient = () =>
  import(
    /* webpackChunkName: "pages/views/modules/checkinout/client/act-client" */ 'views/modules/CheckInOut/client/ActClient'
  );
const ActTransfer = () =>
  import(
    /* webpackChunkName: "pages/views/modules/checkinout/transfer/act-transfer" */ 'views/modules/CheckInOut/transfer/ActTransfer'
  );
const OkData = () =>
  import(
    /* webpackChunkName: "pages/views/modules/checkinout/shared/okdata" */ 'views/modules/CheckInOut/shared/OkData'
  );
const Sign = () =>
  import(
    /* webpackChunkName: "pages/views/modules/checkinout/client/sign" */ 'views/modules/CheckInOut/client/Sign'
  );
const TransferSign = () =>
  import(
    /* webpackChunkName: "pages/views/modules/checkinout/transfer/sign" */ 'views/modules/CheckInOut/transfer/Sign'
  );
const SignCompleted = () =>
  import(
    /* webpackChunkName: "pages/views/modules/checkinout/shared/sign-completed"  */ 'views/modules/CheckInOut/shared/SignCompleted'
  );

// Redirect to the error page
const redirectToErrorPage = (next, resource) =>
  next({
    name: 'error',
    params: { resource }
  });

export default [
  {
    path: '/checkinout',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'acts' // Redirige a la ruta 'acts' por defecto
      },
      {
        path: 'acts',
        name: 'acts',
        component: ManagerActs,
        meta: {
          titleKey: 'acts',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.CAMPS_COORDINATOR]
        },

        beforeEnter(to, from, next) {
          const promises = [
            store.dispatch(`ui/${UI_GET_CHEKINOUT_MASTER_DATA}`), //  Mantener como primera llamada.
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'acts'
            })
          ];
          Promise.all(promises)
            .then(resp => {
              const defaultStorageParks = resp[0];
              if (defaultStorageParks) {
                // TODO [ Validar si es transfer ó cliente para guardar idStoragePark en donde corresponde ]
                store.commit(`act/${SET_ACT_PROPERTY}`, {
                  field: 'identityData.idStoragePark',
                  value: defaultStorageParks.id
                });
                store.commit(`act/${SET_ACT_PROPERTY}`, {
                  field: 'checkTransferFilters.idStoragePark',
                  value: defaultStorageParks.id
                });
              }
              next();
            })
            .catch(() => {
              redirectToErrorPage(next, ACT_GET_ACTS);
            });
        }
      },
      {
        path: 'act-client/:plate([0-9]{4}[BCDFGHJKLMNPRSTVWXYZ]{3})',
        name: 'act-client',
        component: ActClient,
        meta: {
          titleKey: 'act',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER, APP_ROLES.CAMPS_COORDINATOR]
        },
        beforeEnter(to, from, next) {
          const promises = [
            store.dispatch(`ui/${UI_GET_CHEKINOUT_MASTER_DATA}`),
            store.dispatch(`act/${ACT_GET_ACT}`, to.params.plate),
            store.dispatch(`act/${GET_REQUIRED_DOCUMENTATION}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'checkinout-concession'
            }),
            store.dispatch(`act/${GET_REQUIRED_DOCUMENTATION}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'checkinout-damage'
            }),
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'grant'
            })
          ];
          Promise.all(promises)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_GET_ACT);
            });
        }
      },
      {
        path: 'act-transfer/:plate([0-9]{4}[BCDFGHJKLMNPRSTVWXYZ]{3})',
        name: 'act-transfer',
        component: ActTransfer,
        meta: {
          titleKey: 'actTransfer',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER, APP_ROLES.CAMPS_COORDINATOR]
        },
        beforeEnter(to, from, next) {
          const promises = [
            store.dispatch(`ui/${UI_GET_CHEKINOUT_MASTER_DATA}`),
            store.dispatch(`act/${ACT_GET_TRANSFER_ACT}`, to.params.plate),
            store.dispatch(`act/${GET_REQUIRED_DOCUMENTATION}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'checkinout-concession'
            }),
            store.dispatch(`act/${GET_REQUIRED_DOCUMENTATION}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'checkinout-damage'
            }),
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'grant'
            })
          ];
          Promise.all(promises)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_GET_ACT);
            });
        }
      },
      {
        path: 'ok-data',
        name: 'ok-data',
        component: OkData,
        meta: {
          titleKey: 'okData',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER, APP_ROLES.CAMPS_COORDINATOR]
        },
        beforeEnter(to, from, next) {
          store
            .dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'grant-ok'
            })
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_CMS);
            });
        }
      },
      {
        path:
          ':transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/client/sign',
        name: 'sign',
        component: Sign,
        meta: {
          titleKey: 'signData',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER, APP_ROLES.CAMPS_COORDINATOR]
        },
        beforeEnter(to, from, next) {
          const partnerId = to.params.partnerId || process.env.DEFAULT_PARTNER;
          const promises = [
            store.dispatch(`ui/${UI_GET_CHEKINOUT_MASTER_DATA}`),
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId,
              patternId: 'driver-summary'
            })
          ];
          if (to.name === 'sign' && !store.getters['act/data']('act') && lsGetAct()) {
            promises.push(
              store.dispatch(`act/${SET_ACT_PROPERTY}`, {
                field: 'act',
                value: lsGetAct()
              })
            );
          }
          // else if (from.name !== 'identityGuid') {
          //   next({
          //     name: 'identityGuid',
          //     params: to.params
          //   });
          // }
          Promise.all(promises)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_CMS);
            });
        }
      },
      {
        path:
          ':transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/transfer/sign',
        name: 'transfer-sign',
        component: TransferSign,
        meta: {
          titleKey: 'signData',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER, APP_ROLES.CAMPS_COORDINATOR]
        },
        beforeEnter(to, from, next) {
          const partnerId = to.params.partnerId || process.env.DEFAULT_PARTNER;
          const promises = [
            store.dispatch(`ui/${UI_GET_CHEKINOUT_MASTER_DATA}`),
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId,
              patternId: 'driver-summary'
            })
          ];
          if (
            to.name === 'transfer-sign' &&
            !store.getters['act/data']('transferAct') &&
            lsGetTransferAct()
          ) {
            promises.push(
              store.dispatch(`act/${SET_ACT_PROPERTY}`, {
                field: 'transferAct',
                value: lsGetTransferAct()
              })
            );
          }
          Promise.all(promises)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_CMS);
            });
        }
      },
      {
        path:
          'completed/:transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/ok',
        name: 'sign-completed',
        component: SignCompleted,
        meta: {
          titleKey: 'signCompleted',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER, APP_ROLES.CAMPS_COORDINATOR]
        },
        beforeEnter(to, from, next) {
          const partnerId = to.params.partnerId || process.env.DEFAULT_PARTNER;
          store
            .dispatch(`act/${ACT_CMS}`, {
              partnerId,
              patternId: 'driver-sign'
            })
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_CMS);
            });
        }
      }
    ]
  }
];
